"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getJWT = exports.invalidateAccessToken = exports.mockAccessTokenResponse = exports.buildAccessToken = void 0;
// TODO: Make fetching of access token possible on dev environment.
var axios_1 = __importStar(require("axios"));
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var constants_1 = require("./constants");
var localStorageHelper = __importStar(require("./helpers/localStorageHelper"));
var isPublicSessionError = function (error) {
    return error.response.status === 401 && error.response.headers.is_public === 'true';
};
var fetchAccessToken = function (mockingOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var response, url, accessToken, error_1, mockedPublicResponse;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                response = void 0;
                if (!!mockingOptions) return [3 /*break*/, 2];
                url = constants_1.IDP_ACCESS_TOKEN_ENDPOINT;
                return [4 /*yield*/, axios_1.default.get(url, {
                        withCredentials: true,
                    })];
            case 1:
                response = _a.sent();
                return [3 /*break*/, 3];
            case 2:
                response = exports.mockAccessTokenResponse(mockingOptions);
                _a.label = 3;
            case 3:
                if (!response.data) {
                    throw new Error('Could not retrieve access token');
                }
                accessToken = exports.buildAccessToken(response);
                return [2 /*return*/, accessToken];
            case 4:
                error_1 = _a.sent();
                if (isPublicSessionError(error_1)) {
                    mockedPublicResponse = exports.mockAccessTokenResponse(constants_1.PUBLIC_ACCESS_TOKEN_PAYLOAD);
                    return [2 /*return*/, exports.buildAccessToken(mockedPublicResponse)];
                }
                throw error_1;
            case 5: return [2 /*return*/];
        }
    });
}); };
var buildAccessToken = function (response) { return ({
    jwt: response.data.access_token,
    expiryTimestamp: response.data.expires_in,
}); };
exports.buildAccessToken = buildAccessToken;
// THIS FUNCTION IS DEPRECATED
// TODO: Find alternative for the jsonwebtoken library
var mockAccessTokenResponse = function (_a) {
    var _b = _a === void 0 ? constants_1.PUBLIC_ACCESS_TOKEN_PAYLOAD : _a, accountId = _b.accountId, userId = _b.userId, profileId = _b.profileId, groupIds = _b.groupIds, modulePermissions = _b.modulePermissions;
    var payload = {
        account_id: typeof accountId === 'string'
            ? accountId
            : constants_1.DEFAULT_MOCKING_VALUES.ACCOUNT_ID,
        user_id: typeof userId === 'string' ? userId : constants_1.DEFAULT_MOCKING_VALUES.USER_ID,
        profile_id: typeof profileId === 'string'
            ? profileId
            : constants_1.DEFAULT_MOCKING_VALUES.PROFILE_ID,
        group_ids: groupIds || [],
        module_permissions: modulePermissions || [],
    };
    return {
        data: {
            // access_token: jwt.sign(payload, PRIVATE_KEY, SIGN_OPTIONS),
            access_token: 'JWT generation deprecated in this js-access-token-lib version',
            // max epoch, since it should not expire in development mode.
            expires_in: constants_1.MAX_UNIX_TIME,
            token_type: 'bearer',
        },
        status: 200,
        statusText: 'OK',
        headers: {},
        config: {
            headers: new axios_1.AxiosHeaders(),
        },
    };
};
exports.mockAccessTokenResponse = mockAccessTokenResponse;
var invalidateAccessToken = function () {
    localStorageHelper.removeAccessToken();
};
exports.invalidateAccessToken = invalidateAccessToken;
var setExpiryTimeout = function (accessToken) {
    var expiryTimestampInMilliseconds = accessToken.expiryTimestamp * 1000;
    setTimeout(exports.invalidateAccessToken, expiryTimestampInMilliseconds);
};
var isExpired = function (accessToken) {
    var decodedToken = jwt_decode_1.default(accessToken.jwt);
    var expiryEpoch = decodedToken.exp;
    var expiryEpochInMilliseconds = expiryEpoch * 1000;
    return (expiryEpochInMilliseconds - constants_1.MS_REFRESH_TOKEN_BEFORE_EXPIRY < Date.now());
};
var getJWT = function (mockingOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var accessToken;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, localStorageHelper.loadAccessToken()];
            case 1:
                accessToken = _a.sent();
                if (!(!accessToken.jwt || isExpired(accessToken))) return [3 /*break*/, 3];
                return [4 /*yield*/, fetchAccessToken(mockingOptions)];
            case 2:
                accessToken = _a.sent();
                localStorageHelper.storeAccessToken(accessToken);
                setExpiryTimeout(accessToken);
                _a.label = 3;
            case 3: return [2 /*return*/, accessToken.jwt];
        }
    });
}); };
exports.getJWT = getJWT;
window.addEventListener('beforeunload', exports.invalidateAccessToken);
//# sourceMappingURL=AccessToken.js.map